import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useAuth, isAdmin } from "../../contexts/AuthContext";
import DevelopmentPriorities from "./DevelopmentPriorities";
import ThePlan from "./ThePlan";

export const pickAssessment = (docs) => docs.find(d => d.status === "draft" && d.source !== "migrated") || docs[0] || null;

// Training tab · one assessment shared by Development Priorities (the lanes) and The Plan (the moved Panel 4s), so edits never clash.
// The Plan section is parked for now (user request 2026-06) — flip HIDE_PLAN to bring it back.
const HIDE_PLAN = true;

export default function TrainingPlan({ playerId, showPlan = true }) {
  const { user } = useAuth();
  const admin = isAdmin(user);
  const [docs, setDocs] = useState(null);
  const [doc, setDoc] = useState(undefined);
  useEffect(() => {
    setDoc(undefined);
    api.listDevAssessments(playerId).then(d => { const l = d.assessments || []; setDocs(l); setDoc(pickAssessment(l)); }).catch(() => { setDocs([]); setDoc(null); });
  }, [playerId]);
  const onDoc = (d) => { setDoc(d); setDocs(l => (l || []).map(x => x.id === d.id ? d : x)); };
  return (
    <>
      <DevelopmentPriorities playerId={playerId} doc={doc} onDoc={onDoc} />
      {showPlan && !HIDE_PLAN && <ThePlan playerId={playerId} doc={doc === undefined ? null : doc} docs={docs} onSelect={setDoc} onDoc={onDoc} canEdit={admin && doc?.status !== "final"} />}
    </>
  );
}
